<template>
  <div>
    <ul class="select-option" style="overflow: hidden">
      <li>
        <el-button
          type="primary"
          icon="iconfont icon-chakanxiangqing"
          @click="seecase"
        >查看详情</el-button>
      </li>
    </ul>
    <el-table
      ref="multipleTable"
      :data="tableData.records"
      border
      tooltip-effect="dark"
      style="width: 100%; margin-top: 15px"
      :row-style="rowStyle"
      :row-class-name="rowClassName"
      @selection-change="selectionChange"
      @row-click="rowClick"
    >
      <el-table-column
        label="序号"
        type="index"
        :index="indexMethod"
        width="50"
        align="center"
      />

      <el-table-column type="selection" width="60" align="center" />
      <el-table-column label="事件id" prop="caseId">
        <template scope="scope">
          <p
            :style="
              scope.row.caseStatus > 0 ? 'color:#639ee8; font-weight:bold;' : ''
            "
          >
            {{ scope.row.caseId }}
          </p>
        </template>
      </el-table-column>
      <el-table-column
        width="180"
        prop="createTime"
        label="报案日期"
      />
      <el-table-column
        prop="recRealName"
        label="受助人姓名"
        show-overflow-tooltip
      />
      <el-table-column
        prop="productName"
        label="所属计划"
        show-overflow-tooltip
      />
      <el-table-column
        prop="caseParentFlowName"
        label="事件状态"
        show-overflow-tooltip
      />
      <el-table-column
        prop="caseFlowName"
        label="当前处理状态"
        show-overflow-tooltip
      />
      <el-table-column
          prop="operateTime"
          label="操作时效"
          show-overflow-tooltip
      >
        <template scope="scope">
          <span :style="onCountingDays(scope.row.createTime) > 120 ? 'color: red' : ''"
          >{{ onCountingDays(scope.row.createTime) || 0 }}</span>
          / 120<span class="marginL5">自然日</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="currentOperatorName"
        label="当前处理账号"
        show-overflow-tooltip
      />
      <el-table-column
        prop="endOperatorName"
        label="最后处理账号"
        show-overflow-tooltip
      />
    </el-table>
    <!-- <div style="text-align: center; margin-top: 25px;">
      <el-pagination
        @current-change="pageChange"
        :page-size="tableData.size"
		:current-page="pageIndex"
        background
        layout="total,prev, pager, next, jumper"
        :total="tableData.total"
      >
      </el-pagination>
    </div> -->
  </div>
</template>

<script>
import NP from 'number-precision' // 使用js精确地执行加法、减法、乘法和除法运算

export default {

  data() {
    return {
      loading: true,
      accessRole: 'ACCESS_MINE',
      limit: 10,
      pageIndex: 1,
      flowCode: '',
      flowCodeArr: [],
      riskCode: '',
      createTime: '',
      operatorTime: '',
      applicantName: '',
      recRealName: '',
      caseId: '',
      recIdno: '',
      accidentType: '',
      currentProcessAccount: '',
      caseTag: '',
      tableData: {
        records: []
      },
      selectRows: [],
      dialogData: [],
      dialogFormVisible: false,
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      currentCode: '',
      formLabelWidth: '120px'
    }
  },
  computed: {
    selectRowsId: function() {
      const idArr = []
      if (this.selectRows.length > 0) {
        this.selectRows.filter((item) => {
          idArr.push(item.userId)
        })
      }
      return idArr
    }
  },

  created() {
    this.$emit('setCurrentMenu', '超期案件')
    this.getallcase()
  },

  methods: {
    /**
     * 计算受助人120天操作时天数
     * @param {string} createTime 申请日期（格式YYYY-MM-DD hh:mm:ss）
     */
    onCountingDays(createTime = '') {
      var dateArray = createTime.split(" ");
      var date = dateArray[0];
      const firstDate = new Date() // 当天时间
      const secondDate = new Date(date)
      const diff = Math.abs(firstDate.getTime() - secondDate.getTime())
      // const result = parseInt(diff / (1000 * 60 * 60 * 24))
      const result = parseInt(NP.divide(diff, NP.times(1000, 60, 60, 24)))
      return result
    },
    filterNull(data) {
      const vm = this
      for (var i = 0; i < data.length; i++) {
        if (data[i].children.length < 1) {
          data[i].children = undefined
        } else {
          vm.filterNull(data[i].children)
        }
      }
      return data
    },

    indexMethod(index) {
      return (this.pageIndex - 1) * this.limit + index + 1
    },

    /**
     * 查询超时案件列表
     */
    getallcase() {
      const vm = this
      vm.axios
        .get(vm.homePath() + '/case/overtime/list')
        .then((response) => {
          const data = response.data
          vm.loading = false
          if (data.status === '000000') {
            const result = response.data.data
            vm.tableData.records = result
          } else {
            vm.$alert(data.message || '服务器繁忙，请稍后重试', '提示')
          }
        })
        .catch((error) => console.log(error))
    },

    rowClick(row, column, event) {
      const refsElTable = this.$refs.multipleTable
      const findRow = this.selectRows.find((c) => c.rowIndex == row.rowIndex)
      if (findRow) {
        refsElTable.toggleRowSelection(row, false)
        return
      }
      refsElTable.clearSelection()
      refsElTable.toggleRowSelection(row)
    },
    rowStyle({ row, rowIndex }) {
      Object.defineProperty(row, 'rowIndex', {
        value: rowIndex,
        writable: true,
        enumerable: false
      })
    },
    rowClassName({ row, rowIndex }) {
      let rowName = ''
      const findRow = this.selectRows.find((c) => c.rowIndex === row.rowIndex)
      if (findRow) {
        rowName = 'current-row '
      }
      return rowName
    },

    selectionChange(rows) {
      this.selectRows = rows
    },
    changeOperator(val) {
      this.currentCode = val.code
    },

    seecase() {
      const vm = this
      if (vm.selectRows.length < 1) {
        vm.$alert('请选择一条记录', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        })
        return
      }

      if (vm.selectRows.length > 1) {
        vm.$alert('只能选择一条记录', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        })
        return
      }

      const currentSearchData = {
        accessRole: vm.accessRole,
        limit: vm.limit,
        pageIndex: vm.pageIndex,
        flowCode: vm.flowCode,
        createTime: vm.createTime,
        operatorTime: vm.operatorTime,
        applicantName: vm.applicantName,
        recRealName: vm.recRealName,
        recIdno: vm.recIdno,
        caseId: vm.caseId,
        caseTag: vm.caseTag,
        accidentType: vm.accidentType,
        currentProcessAccount: vm.currentProcessAccount
      }

      localStorage.setItem(
        'currentSearchData',
        JSON.stringify(currentSearchData)
      )
      this.$router.push({
        path: '/index/caseDetailV2/' + vm.selectRows[0].caseCode,
        query: {
          from: 'overtime'
        }
      })
    }
  }
}
</script>

<style>
.select-title {
  font-size: 14px;
  font-weight: 700;
}
.select-option li {
  float: left;
  margin: 10px;
}
.select-input {
  width: auto;
}
.el-table td,
.el-table th {
  padding: 6px 0px;
}
.el-table th {
  color: #333;
  font-weight: bold;
  text-align: center;
}
</style>
